// 全局存储当前弹窗的产品数据
let currentProductData = null;

// 颜色标签列表
const COLOR_LABELS = ['color', 'farve', 'farbe', 'couleur', 'cor', 'colour'];

// SET标签列表（使用和size相同的样式）
const SET_LABELS = ['set'];

/**
 * 打开全局弹窗并填充产品数据
 * @param {Object} productData - 产品数据对象
 * @param {string} productData.id - 产品ID
 * @param {string} productData.title - 产品标题
 * @param {string} productData.url - 产品URL
 * @param {Array} productData.variants - 产品变体数组
 * @param {Array} productData.options - 产品选项数组
 * @param {string} productData.featuredImage - 产品特色图片URL
 */
function openGlobalPopup(productData) {
  if (!productData) {
    console.error('No product data provided');
    return;
  }

  // 保存当前产品数据
  currentProductData = productData;

  const popup = document.getElementById('global-popup-overlay');
  if (!popup) {
    console.error('Global popup not found');
    return;
  }

  popup.setAttribute('data-hemi-atc-location', productData.analyticsLocation || 'quick_add');

  // 更新产品标题
  const titleElement = popup.querySelector('.product-title');
  if (titleElement) {
    titleElement.textContent = productData.title || '';
  }

  // 渲染产品选项
  renderProductOptions(productData);

  // 保存当前滚动位置
  const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  // 显示弹窗
  popup.style.display = 'flex';
  document.body.classList.add('popup-open');

  // 恢复滚动位置
    requestAnimationFrame(() => {
      window.scrollTo({
        top: scrollPosition,
      behavior: 'auto',
    });
  });
}

/**
 * 渲染产品选项
 */
function renderProductOptions(productData) {
  const container = document.querySelector('#global-popup-overlay .popup-options-container');
  if (!container) return;

  // 清空容器
  container.innerHTML = '';

  if (!productData.options || !productData.variants) {
    container.innerHTML = '<p class="text-center">No options available</p>';
    return;
  }

  // 解析选项和值
  const optionsWithValues = parseOptionsWithValues(productData);

  // 渲染每个选项
  optionsWithValues.forEach((option, optionIndex) => {
    const isColorOption = isColorLabel(option.name);
    const isSetOption = isSetLabel(option.name);
    const optionDiv = createOptionElement(option, optionIndex, isColorOption, isSetOption, productData);
    container.appendChild(optionDiv);
  });
}

/**
 * 解析产品选项和值
 */
function parseOptionsWithValues(productData) {
  const { options, variants } = productData;
  
  // 创建选项对象数组
  const optionsWithValues = options.map((optionName, index) => {
    const values = new Set();
    const valuesWithAvailability = [];

    // 遍历所有变体，收集该选项的所有值
    // 只要有任意一个该选项值的变体可购买（有库存或允许超卖），就标记为可用
    variants.forEach(variant => {
      const value = variant.options[index];
      if (value) {
        const available = isVariantAvailable(variant);
        if (!values.has(value)) {
          values.add(value);
          valuesWithAvailability.push({
            value: value,
            available: available,
            variant: variant
          });
        } else if (available) {
          const existing = valuesWithAvailability.find(v => v.value === value);
          if (existing && !existing.available) {
            existing.available = true;
            existing.variant = variant;
          }
        }
      }
    });

    return {
      name: optionName,
      position: index + 1,
      values: valuesWithAvailability
    };
  });

  return optionsWithValues;
}

/**
 * 判断变体是否可购买
 * inventory_policy 为 "continue" 时即使缺货也允许销售
 */
function isVariantAvailable(variant) {
  if (!variant) return false;
  return variant.available === true || variant.inventory_policy === 'continue';
}

/**
 * 检查是否是颜色标签
 */
function isColorLabel(optionName) {
  const lowerName = optionName.toLowerCase();
  return COLOR_LABELS.some(label => lowerName.includes(label));
}

/**
 * 检查是否是SET标签
 */
function isSetLabel(optionName) {
  const lowerName = optionName.toLowerCase();
  return SET_LABELS.some(label => lowerName === label);
}

/**
 * 检查是否是鞋履尺码选项，避免把服装 Size 也进行地区换算
 */
function isShoeSizeLabel(optionName) {
  const lowerName = String(optionName || '').toLowerCase();
  return lowerName.includes('shoe') && lowerName.includes('size');
}

/**
 * 将后台保存的鞋码换算为当前市场展示的尺码
 */
function getLocalizedShoeSize(value) {
  const rawValue = String(value || '');
  const storedToEu = {
    '4': '34',
    '5': '35',
    '6': '36',
    '6.5': '37',
    '7.5': '38',
    '8.5': '39',
    '9': '40',
    '10': '41',
    '11': '42'
  };
  const euValue = storedToEu[rawValue] || rawValue;
  const countryCode = String(window.Shopify?.country || '').toUpperCase();
  const usAndCaAu = {
    '34': '4',
    '35': '5',
    '36': '6',
    '37': '6.5',
    '38': '7.5',
    '39': '8.5',
    '40': '9',
    '41': '10',
    '42': '11'
  };
  const uk = {
    '34': '2',
    '35': '3',
    '36': '4',
    '37': '4.5',
    '38': '5.5',
    '39': '6.5',
    '40': '7',
    '41': '8',
    '42': '9'
  };
  const jp = {
    '34': '21',
    '35': '22',
    '36': '23',
    '37': '23.5',
    '38': '24.5',
    '39': '25.5',
    '40': '26',
    '41': '27',
    '42': '28'
  };

  if (['US', 'CA', 'AU'].includes(countryCode)) return usAndCaAu[euValue] || euValue;
  if (countryCode === 'GB') return uk[euValue] || euValue;
  if (countryCode === 'JP') return jp[euValue] || euValue;
  return euValue;
}

/**
 * 创建选项元素
 */
function createOptionElement(option, optionIndex, isColorOption, isSetOption, productData) {
  const optionDiv = document.createElement('div');
  optionDiv.className = `js product-form__input product-form__input--pill ${
    isColorOption ? 'product-form__input--color' : 'product-form__input--size'
  }`;

  // 创建标签
  const label = document.createElement('span');
  label.className = 'form__label';
  label.textContent = `${isShoeSizeLabel(option.name) ? 'Size' : option.name}:`;
  optionDiv.appendChild(label);

  // 创建值容器
  const valuesContainer = document.createElement('div');
  valuesContainer.className = 'values-container';

  // 渲染每个值
  option.values.forEach((valueObj, valueIndex) => {
    if (isColorOption) {
      const colorElement = createColorOption(option, valueObj, valueIndex, optionIndex, productData);
      valuesContainer.appendChild(colorElement);
    } else {
      // SET选项和Size选项使用相同的样式，但SET默认选中第一个
      const isFirstValue = valueIndex === 0;
      const shouldAutoSelect = isSetOption && isFirstValue;
      const sizeElement = createSizeOption(option, valueObj, valueIndex, optionIndex, productData, shouldAutoSelect, isSetOption);
      valuesContainer.appendChild(sizeElement);
    }
  });

  optionDiv.appendChild(valuesContainer);
  return optionDiv;
}

/**
 * 创建颜色选项
 */
function createColorOption(option, valueObj, valueIndex, optionIndex, productData) {
  const wrapper = document.createElement('div');
  wrapper.className = 'color-option-wrapper';

  const inputId = `global-popup-${productData.id}-${option.position}-${valueIndex}`;
  const inputName = `${option.name}-${option.position}`;

  // 创建radio input
  const input = document.createElement('input');
  input.type = 'radio';
  input.id = inputId;
  input.name = inputName;
  input.value = valueObj.value;
  input.dataset.optionValue = valueObj.value;
  input.dataset.optionPosition = option.position;

  // 第一个可用选项设为选中
  const isFirstAvailable = valueIndex === 0 && valueObj.available;
  if (isFirstAvailable) {
    input.checked = true;
  }

  if (!valueObj.available) {
    input.disabled = true;
    input.classList.add('disabled');
  }

  wrapper.appendChild(input);

  // 创建label（色块）
  const label = document.createElement('label');
  label.className = `color-swatch ${
    !valueObj.available ? 'disabled' : ''
  }`;
  label.htmlFor = inputId;

  // 从预处理的颜色数据中获取颜色信息
  const colorData = getColorDataFromSwatches(valueObj.value, productData.colorSwatches);

  if (colorData && colorData.color) {
    label.style.backgroundColor = colorData.color;
  } else if (colorData && colorData.image) {
    const img = document.createElement('img');
    img.src = colorData.image;
    img.alt = valueObj.value;
    label.appendChild(img);
  }

  wrapper.appendChild(label);
  return wrapper;
}

/**
 * 创建尺寸选项
 */
function createSizeOption(option, valueObj, valueIndex, optionIndex, productData, shouldAutoSelect = false, isSetOption = false) {
  // 创建表单
  const form = document.createElement('form');
  form.className = 'form';
  form.dataset.type = 'add-to-cart-form';
  form.dataset.productId = productData.id;
  form.addEventListener('submit', handleSizeOptionSubmit);

  // 创建隐藏的variant ID输入框
  const variantInput = document.createElement('input');
  variantInput.type = 'hidden';
  variantInput.name = 'id';
  variantInput.className = 'product-variant-id';
  variantInput.dataset.sizeValue = valueObj.value;
  variantInput.dataset.optionPosition = option.position;
  variantInput.dataset.isShoeSize = String(isShoeSizeLabel(option.name));
  form.appendChild(variantInput);

  // 创建按钮
  const button = document.createElement('button');
  button.type = 'submit';
  button.name = 'add';
  button.className = `size-option-btn product-form__submit ${
    !valueObj.available ? 'disabled' : ''
  } ${shouldAutoSelect ? 'selected' : ''}`;
  
  if (!valueObj.available) {
    button.disabled = true;
  }
  
  // 如果需要自动选中（SET选项的第一个值）
  if (shouldAutoSelect && valueObj.available) {
    button.classList.add('selected');
  }
  
  // 为SET选项添加特殊标记和点击事件
  if (isSetOption) {
    button.dataset.isSetOption = 'true';
    button.addEventListener('click', function(e) {
      // 移除同组其他按钮的选中状态
      const allSetButtons = form.parentElement.querySelectorAll('.size-option-btn[data-is-set-option="true"]');
      allSetButtons.forEach(btn => btn.classList.remove('selected'));
      // 添加当前按钮的选中状态
      if (!this.disabled && !this.classList.contains('disabled')) {
        this.classList.add('selected');
      }
    });
  }

  // 创建按钮内容
  const span = document.createElement('span');
  span.textContent = isShoeSizeLabel(option.name)
    ? getLocalizedShoeSize(valueObj.value)
    : valueObj.value;
  button.appendChild(span);

  // 创建加载动画
  const spinner = document.createElement('svg');
  spinner.className = 'spinner hidden';
  spinner.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  spinner.setAttribute('fill', 'none');
  spinner.setAttribute('viewBox', '0 0 24 24');
  spinner.innerHTML = `
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  `;
  button.appendChild(spinner);

  form.appendChild(button);
  return form;
}

/**
 * 将字符串转换为Shopify handle格式（模拟Liquid的handleize过滤器）
 */
function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')  // 替换非字母数字字符为连字符
    .replace(/^-+|-+$/g, '');      // 移除开头和结尾的连字符
}

/**
 * 从全局颜色映射中获取颜色信息
 */
function getColorDataFromSwatches(colorValue, swatches) {
  // 1. 首先尝试从产品特定的swatches中查找（最准确）
  if (swatches && Array.isArray(swatches) && swatches.length > 0) {
    const swatch = swatches.find(s => s.name === colorValue);
    
    if (swatch && swatch.color) {
      return {
        color: swatch.color,
        image: swatch.image || ''
      };
    }
  }

  // 2. 如果产品数据中没有，尝试使用全局Shopify颜色查询函数
  if (typeof window.getShopifyColor === 'function') {
    const color = window.getShopifyColor(colorValue);
    
    if (color) {
      return {
        color: color,
        image: ''
      };
    }
  }

  // 3. 最后的fallback：尝试从swatches的debug信息中查找
  if (swatches && Array.isArray(swatches)) {
    const swatch = swatches.find(s => s.name === colorValue);
    if (swatch) {
      let finalColor = swatch.color || '';
      
      // 如果metaobject颜色是黑色或无效，尝试使用swatch的原始颜色
      if (finalColor === '#000000' || finalColor === '#000' || finalColor === 'black' || finalColor === '') {
        const debug = swatch.debug;
        if (debug) {
          // 优先使用原始swatch的hex颜色
          if (debug.raw_swatch_hex && debug.raw_swatch_hex !== '' && debug.raw_swatch_hex !== '#000000' && !debug.raw_swatch_hex.startsWith('rgb_')) {
            finalColor = '#' + debug.raw_swatch_hex;
          }
          // 如果hex是RGB格式，从RGB构建颜色
          else if (debug.raw_swatch_hex && debug.raw_swatch_hex.startsWith('rgb_')) {
            const rgbString = debug.raw_swatch_hex.replace('rgb_', '');
            const rgbValues = rgbString.split(/\s+/).map(v => parseInt(v.trim()));
            if (rgbValues.length === 3 && !rgbValues.some(v => isNaN(v))) {
              finalColor = `rgb(${rgbValues.join(', ')})`;
            }
          }
          // 如果没有hex，尝试从RGB构建颜色
          else if (debug.raw_swatch_rgb && debug.raw_swatch_rgb !== '') {
            const rgbValues = debug.raw_swatch_rgb.split(/[,\s]+/).map(v => parseInt(v.trim()));
            if (rgbValues.length === 3 && !rgbValues.some(v => isNaN(v))) {
              finalColor = `rgb(${rgbValues.join(', ')})`;
            }
          }
          // 最后尝试使用原始swatch颜色
          else if (debug.raw_swatch_color && debug.raw_swatch_color !== '' && debug.raw_swatch_color !== '#000000') {
            finalColor = debug.raw_swatch_color;
          }
        }
      }
      
      return {
        color: finalColor,
        image: swatch.image || ''
      };
    }
  }

  return {};
}

/**
 * 处理尺寸选项提交
 */
function handleSizeOptionSubmit(e) {
    e.preventDefault();

  if (!currentProductData) {
    showNotification('Product data not found', 'error');
    return;
  }

    const form = e.target;
  const button = form.querySelector('.size-option-btn');

    // 检查按钮是否被禁用
  if (button && (button.disabled || button.classList.contains('disabled'))) {
      return false;
    }

    // 获取选中的颜色值
  const selectedColorInput = document.querySelector('#global-popup-overlay input[type="radio"]:checked');
    const selectedColor = selectedColorInput ? selectedColorInput.value : null;

    // 获取当前尺寸值
  const variantInput = form.querySelector('.product-variant-id');
  const sizeValue = variantInput.dataset.sizeValue;
  const localizedSize = variantInput.dataset.isShoeSize === 'true'
    ? getLocalizedShoeSize(sizeValue)
    : null;

  // 找到对应的variant ID
  const variantId = findVariantIdByOptions(currentProductData, selectedColor, sizeValue);

    if (!variantId) {
    showNotification('find no matching product', 'error');
      return;
    }

    // 显示loading状态
  button.classList.add('loading');
    button.disabled = true;

  // 添加到购物车
  addToCart(variantId, button, currentProductData, localizedSize);
}

/**
 * 根据选项查找variant ID
 */
function findVariantIdByOptions(productData, colorValue, sizeValue) {
  const { variants, options } = productData;

  if (!variants || !options) return null;

  // 找到颜色和尺寸选项的索引
  const colorIndex = options.findIndex(opt => isColorLabel(opt));
  const sizeIndex = options.findIndex(opt => {
    const lower = opt.toLowerCase();
    return lower.includes('size') || lower.includes('taille');
  });
  
  // 查找SET选项索引
  const setIndex = options.findIndex(opt => isSetLabel(opt));

  // 查找匹配的variant
  const variant = variants.find(v => {
    const opts = v.options || [];
    const colorOk = colorIndex === -1 || !colorValue || opts[colorIndex] === colorValue;
    const sizeOk = sizeIndex === -1 || !sizeValue || opts[sizeIndex] === sizeValue;
    const setOk = setIndex === -1 || !sizeValue || opts[setIndex] === sizeValue;
    return colorOk && sizeOk && setOk;
  });

  return variant ? variant.id : null;
}

/**
 * 添加到购物车
 */
function addToCart(variantId, button, productData, localizedSize = null) {
  const analyticsAttempt = window.HemiAnalytics?.begin(button, { id: variantId, productId: productData.id }, productData.analyticsLocation || 'quick_add');
    const requestData = {
    id: variantId,
      quantity: 1,
    };

  if (localizedSize) {
    requestData.properties = { Size: localizedSize };
  }

  // 获取购物车组件
  const cartComponent = document.querySelector('alp-cart-toast') || document.querySelector('cart-drawer');
    if (cartComponent && cartComponent.getSectionsToRender) {
    requestData.sections = cartComponent.getSectionsToRender().map(section => section.id);
      requestData.sections_url = window.location.pathname;
    }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(requestData),
    })
    .then(response => { if (!response.ok) window.HemiAnalytics?.result(analyticsAttempt, response); return response.json(); })
    .then(data => {
        if (data.status && data.status !== 200) {
        throw new Error(data.description || 'add to cart failed');
        }

      window.HemiAnalytics?.result(analyticsAttempt, { ok: true });
      // 发布购物车更新事件
        if (window.publish && window.PUB_SUB_EVENTS) {
        const startMarker = typeof CartPerformance !== 'undefined' 
          ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
          : null;

          publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
            productVariantId: variantId,
            cartData: data,
          }).then(() => {
          if (startMarker && typeof CartPerformance !== 'undefined') {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          }
        });
      }

      // 触发主题的购物车添加事件
      document.dispatchEvent(
        new CustomEvent('theme:cart::added', {
          detail: {
            button: button,
            product: productData,
            data: { id: variantId, quantity: 1 }
          }
        })
      );

      // 使用主题的购物车控制器更新购物车（优先）
      if (window.theme && window.theme.Cart && typeof window.theme.Cart.updateData === 'function') {
        window.theme.Cart.updateData().then(() => {
          if (typeof window.theme.Cart.updateCart === 'function') {
            window.theme.Cart.updateCart();
          }
        });
      } 
      // 降级方案：使用AlpFn更新购物车
      else if (window.AlpFn) {
        if (typeof window.AlpFn.UpdateCartCount === 'function') {
          window.AlpFn.UpdateCartCount();
        }
        
        // 刷新购物车内容
        if (typeof window.AlpFn.refreshCart === 'function') {
          const cartDrawer = document.querySelector('[data-ajax-cart]');
          if (cartDrawer) {
            window.AlpFn.refreshCart('[data-ajax-cart]');
          }
        }
      }

      // 显示购物车提示
      showProductAddedToast(data, productData);

      // 关闭弹窗
      closeGlobalPopup();
    })
    .catch(error => {
      window.HemiAnalytics?.result(analyticsAttempt, null);
      console.error('Add to cart failed:', error);
      showNotification(error.message || 'Add to cart failed', 'error');
    })
    .finally(() => {
      // 移除loading状态
      button.classList.remove('loading');
      button.disabled = false;

      // 更新购物车状态
      const cart = document.querySelector('cart-drawer');
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    });
}

/**
 * 显示购物车提示
 */
function showProductAddedToast(cartData, productData) {
  // 调用全局的showCartToast函数（定义在alp-cart-toast.liquid中）
  if (typeof window.showCartToast !== 'function') {
    return;
  }

  // 构建产品数据对象
  const product = {
    title: productData ? productData.title : 'Product',
    image: productData ? productData.featuredImage : null
  };

  // 如果API返回了产品信息，使用更详细的数据
  if (cartData && cartData.items && cartData.items.length > 0) {
    const lastItem = cartData.items[cartData.items.length - 1];
    product.title = lastItem.product_title || product.title;
    product.image = lastItem.image || product.image;
  }

  // 调用全局toast函数
  window.showCartToast(product);
}

/**
 * 关闭全局弹窗
 */
function closeGlobalPopup() {
  const popup = document.getElementById('global-popup-overlay');
        if (popup) {
    popup.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.body.style.overflow = '';
  }
  
  // 清空当前产品数据
  currentProductData = null;
}

// 统一的点击事件处理器（使用捕获阶段优先处理）
document.addEventListener('click', function (e) {
  // 1. 防止缺货选项被点击（最高优先级）
  if (e.target.classList.contains('color-swatch') && e.target.classList.contains('disabled')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  if (e.target.classList.contains('size-option-btn') && e.target.classList.contains('disabled')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  if (e.target.type === 'radio' && e.target.classList.contains('disabled')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // 2. 处理快速添加按钮点击
  const trigger = e.target?.closest?.('.quick-add-trigger');
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();

  // 从data属性读取产品数据
  try {
    // 安全解析JSON的辅助函数
    const safeJSONParse = (str, defaultValue = []) => {
      if (!str || str.trim() === '') {
        return defaultValue;
      }
      try {
        return JSON.parse(str);
      } catch (e) {
        console.warn('JSON parse error:', e, 'Input:', str);
        return defaultValue;
      }
    };

    const productData = {
      analyticsLocation: window.HemiAnalytics?.source(trigger) || 'quick_add',
      id: trigger.dataset.productId,
      title: trigger.dataset.productTitle,
      url: trigger.dataset.productUrl,
      variants: safeJSONParse(trigger.dataset.productVariants, []),
      options: safeJSONParse(trigger.dataset.productOptions, []),
      featuredImage: trigger.dataset.productImage,
      colorSwatches: safeJSONParse(trigger.dataset.colorSwatches, []),
    };

    openGlobalPopup(productData);
  } catch (error) {
    console.error('Failed to parse product data:', error);
    showNotification('Failed to load product data', 'error');
  }
    return;
  }

  // 3. 点击遮罩层关闭弹窗
  if (e.target.id === 'global-popup-overlay') {
    closeGlobalPopup();
  }
});

// ESC键关闭弹窗
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const popup = document.getElementById('global-popup-overlay');
    if (popup && popup.style.display === 'flex') {
      closeGlobalPopup();
    }
  }
});

// Toast 弹窗函数
function showToast(message, type = 'info', duration = 3000) {
  // 创建 toast 容器（如果不存在）
  let toastContainer = document.getElementById('toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 10px;
      pointer-events: none;
    `;
    document.body.appendChild(toastContainer);
  }

  // 创建 toast 元素
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;

  // 设置样式
  const baseStyles = {
    background: '#fff',
    border: '1px solid #e5e5e5',
    borderRadius: '8px',
    padding: '12px 16px',
    minWidth: '300px',
    maxWidth: '400px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    fontSize: '14px',
    lineHeight: '1.4',
    color: '#333',
    opacity: '0',
    transform: 'translateX(100%)',
    transition: 'all 0.3s ease-in-out',
    pointerEvents: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    position: 'relative',
  };

  // 根据类型设置不同的颜色
  const typeStyles = {
    success: {
      borderLeft: '4px solid #10b981',
      background: '#f0fdf4',
    },
    error: {
      borderLeft: '4px solid #ef4444',
      background: '#fef2f2',
    },
    warning: {
      borderLeft: '4px solid #f59e0b',
      background: '#fffbeb',
    },
    info: {
      borderLeft: '4px solid #3b82f6',
      background: '#eff6ff',
    },
  };

  // 应用样式
  Object.assign(toast.style, baseStyles, typeStyles[type] || typeStyles.info);

  // 添加图标
  const iconMap = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };

  const icon = document.createElement('span');
  icon.style.cssText = `
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
  `;
  icon.textContent = iconMap[type] || iconMap.info;
  toast.appendChild(icon);

  // 添加消息内容
  const messageEl = document.createElement('span');
  messageEl.textContent = message;
  messageEl.style.flex = '1';
  toast.appendChild(messageEl);

  // 添加关闭按钮
  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '×';
  closeBtn.style.cssText = `
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;
    padding: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
  `;
  closeBtn.addEventListener('click', () => removeToast(toast));
  closeBtn.addEventListener('mouseenter', () => {
    closeBtn.style.backgroundColor = '#f3f4f6';
  });
  closeBtn.addEventListener('mouseleave', () => {
    closeBtn.style.backgroundColor = 'transparent';
  });
  toast.appendChild(closeBtn);

  // 添加到容器
  toastContainer.appendChild(toast);

  // 触发动画
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(0)';
  });

  // 自动移除
  const timer = setTimeout(() => {
    removeToast(toast);
  }, duration);

  // 鼠标悬停时暂停自动移除
  toast.addEventListener('mouseenter', () => {
    clearTimeout(timer);
  });

  toast.addEventListener('mouseleave', () => {
    setTimeout(() => {
      removeToast(toast);
    }, 1000);
  });

  return toast;
}

// 移除 toast 的函数
function removeToast(toast) {
  if (!toast || !toast.parentNode) return;

  toast.style.opacity = '0';
  toast.style.transform = 'translateX(100%)';

  setTimeout(() => {
    if (toast.parentNode) {
      toast.parentNode.removeChild(toast);
    }
  }, 300);
}

// 简单的通知函数
function showNotification(message, type = 'info') {
  showToast(message, type);
}

// ========== 兼容旧版本API ==========
// 保留向后兼容性
const popupProductDataMap = new Map();

function initPopupProductOptions(variants, options, triggerId) {
  console.warn('initPopupProductOptions is deprecated. Use openGlobalPopup instead.');
  if (!triggerId) return;
  popupProductDataMap.set(triggerId, {
    variants: Array.isArray(variants) ? variants : [],
    options: Array.isArray(options) ? options : [],
  });
}

function openPopup(triggerId) {
  console.warn('openPopup is deprecated. Use openGlobalPopup instead.');
  // 尝试从旧的数据映射中获取数据
  const data = popupProductDataMap.get(triggerId);
  if (data) {
    openGlobalPopup({
      id: triggerId,
      title: 'Product', // 需要从DOM中获取
      variants: data.variants,
      options: data.options 
    });
  }
}

function closePopup(triggerId) {
  console.warn('closePopup is deprecated. Use closeGlobalPopup instead.');
  closeGlobalPopup();
}

